// extracted by mini-css-extract-plugin
export var localeSelector = "_ab-0";